/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_8_ClientInputs */

const et_portfolio_project_8_client = /** @type {(inputs: Portfolio_Project_8_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vama Kali Ashram (Teadveloleku stuudio)`)
};

const en_portfolio_project_8_client = /** @type {(inputs: Portfolio_Project_8_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vama Kali Ashram (Mindfulness studio)`)
};

/**
* | output |
* | --- |
* | "Vama Kali Ashram (Mindfulness studio)" |
*
* @param {Portfolio_Project_8_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_8_client = /** @type {((inputs?: Portfolio_Project_8_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_8_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_8_client(inputs)
	return en_portfolio_project_8_client(inputs)
});